import RCPagination, { PaginationProps } from 'rc-pagination';
import { ArrowNextIcon } from '../custom-icons/ArrowNextIcon';
import { ArrowPrevIcon } from '../custom-icons/ArrowPrevIcon';
import 'rc-pagination/assets/index.css';

const Pagination = (props) => {
  return (
    <RCPagination
      nextIcon={<ArrowNextIcon />}
      prevIcon={<ArrowPrevIcon />}
      {...props}
    />
  );
};

export default Pagination;
